module.exports = __webpack_public_path__ + "static/media/three-dots.7117e317.svg";